// frontend/src/helpers/sourceImages.js
export const sourceImages = require.context('../assets/images', true);

